import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_12 = { class: "control-label col-sm-6" }
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_15 = { class: "control-label col-sm-6" }
const _hoisted_16 = { class: "col-sm" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_19 = { class: "control-label col-sm-6" }
const _hoisted_20 = { class: "col-sm" }
const _hoisted_21 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_22 = { class: "control-label col-sm-6" }
const _hoisted_23 = { class: "col-sm" }
const _hoisted_24 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_25 = { class: "control-label col-sm-6" }
const _hoisted_26 = { class: "col-sm" }
const _hoisted_27 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_28 = { class: "control-label col-sm-6" }
const _hoisted_29 = { class: "col-sm" }
const _hoisted_30 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_31 = { class: "control-label col-sm-6" }
const _hoisted_32 = { class: "col-sm" }
const _hoisted_33 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_34 = { class: "control-label col-sm-6" }
const _hoisted_35 = { class: "col-sm" }
const _hoisted_36 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_37 = { class: "control-label col-sm-6" }
const _hoisted_38 = { class: "col-sm" }
const _hoisted_39 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_40 = { class: "control-label col-sm-6" }
const _hoisted_41 = { class: "col-sm" }

import { watch , ref, inject } from 'vue'
import { usePreventivo } from '../../composable/usePreventivo';
import FormSocietarioHelper from "../../pages/preventivi/json/societario/helper.json";
import DettaglioPreventivoHelper from "./../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormSocietarioCessioneAziende',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo', 'infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categorieValidazione
} = usePreventivo();
const props = __props;
const emits = __emit;
let validazione;
const validazioneEquoCompenso = ref();
const { regimeFiscale } = inject('regimeFiscale')
switch (props.formName) {
  case 'cessioneAziendeSenzaImmobili':
    validazione = categorieValidazione.categoriaSocietario['sottocategoriaCessioneAziende']['cessioneAziendeSenzaImmobili'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaSocietario['sottocategoriaCessioneAziende']['cessioneAziendeSenzaImmobili'];
    break
  case 'cessioneAziendeConImmobili':
    validazione = categorieValidazione.categoriaSocietario['sottocategoriaCessioneAziende']['cessioneAziendeConImmobili'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaSocietario['sottocategoriaCessioneAziende']['cessioneAziendeConImmobili'];
    break
}
const testoInfoCompilazione = ref([]);
testoInfoCompilazione.value =  FormSocietarioHelper.sottocategoriaCessioneAziende[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
watch(validazione, (newValue, oldValue) => {
  emits('changeDatiPreventivo')
}, { deep: true });
let indexHelperClosing = {
  calcolo: FormSocietarioHelper.sottocategoriaCessioneAziende[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}
if(validazione){
  validazione.tipo_preventivo.value = 'societario/cessione_aziende/' + props.tipoPreventivo.data.url
}

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'cessioneAziendeSenzaImmobili')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).valore_azienda.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_azienda.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_input_text, {
                id: "valore_azienda",
                name: "valore_azienda",
                class: "placeholder-right crm:text-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).valore_azienda,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).valore_azienda) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(validazione).valore_crediti_ceduti.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_crediti_ceduti.ref]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_input_text, {
                id: "valore_crediti_ceduti",
                name: "valore_crediti_ceduti",
                class: "placeholder-right crm:text-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).valore_crediti_ceduti,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).valore_crediti_ceduti) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
              _createTextVNode(_toDisplayString(_unref(validazione).tipo_societa.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_societa.ref]
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_base_select, {
                name: "tipo_societa",
                options: [{name: 'Ditte Individuali', value: 'ditte_individuali'},
            {name: 'Società di persone', value: 'societa_di_persone'},{name: 'Società di capitale', value: 'societa_di_capitale'}],
                state: __props.readonly == true ?'disable':'',
                validateTo: _unref(validazione).tipo_societa,
                "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).tipo_societa) = $event))
              }, null, 8 /* PROPS */, ["state", "validateTo"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
              _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_base_select, {
                name: "forma_del_titolo",
                options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                isSelected: _unref(validazione).forma_del_titolo.value != '',
                state: __props.readonly == true ?'disable':'',
                validateTo: _unref(validazione).forma_del_titolo,
                "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).forma_del_titolo) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          (_unref(regimeFiscale) == 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_15, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "valore_azienda",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'cessioneAziendeConImmobili')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_19, [
                _createTextVNode(_toDisplayString(_unref(validazione).valore_azienda.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_azienda.ref]
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_base_input_text, {
                  id: "valore_azienda",
                  name: "valore_azienda",
                  class: "placeholder-right crm:text-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).valore_azienda,
                  "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).valore_azienda) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_22, [
                _createTextVNode(_toDisplayString(_unref(validazione).valore_fabbricati.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_fabbricati.ref]
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_base_input_text, {
                  id: "valore_fabbricati",
                  name: "valore_fabbricati",
                  class: "placeholder-right crm:text-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).valore_fabbricati,
                  "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).valore_fabbricati) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_25, [
                _createTextVNode(_toDisplayString(_unref(validazione).valore_crediti_ceduti.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_crediti_ceduti.ref]
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_base_input_text, {
                  id: "valore_crediti_ceduti",
                  name: "valore_crediti_ceduti",
                  class: "placeholder-right crm:text-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).valore_crediti_ceduti,
                  "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).valore_crediti_ceduti) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_28, [
                _createTextVNode(_toDisplayString(_unref(validazione).tipo_societa.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_societa.ref]
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_base_select, {
                  name: "tipo_societa",
                  options: [{name: 'Ditte Individuali', value: 'ditte_individuali'},
            {name: 'Società di persone', value: 'societa_di_persone'},{name: 'Società di capitale', value: 'societa_di_capitale'}],
                  state: __props.readonly == true ?'disable':'',
                  validateTo: _unref(validazione).tipo_societa,
                  "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).tipo_societa) = $event))
                }, null, 8 /* PROPS */, ["state", "validateTo"])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_31, [
                _createTextVNode(_toDisplayString(_unref(validazione).valore_terreni.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_terreni.ref]
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_base_input_text, {
                  id: "valore_terreni",
                  name: "valore_terreni",
                  class: "placeholder-right crm:text-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).valore_terreni,
                  "onUpdate:validateTo": _cache[9] || (_cache[9] = $event => ((_unref(validazione).valore_terreni) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_34, [
                _createTextVNode(_toDisplayString(_unref(validazione).terreno_agricolo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.terreno_agricolo.ref]
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_base_input_checkbox, {
                  class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                  name: "terreno_agricolo",
                  label: "Sì, terreno agricolo",
                  "validate-to": _unref(validazione).terreno_agricolo,
                  "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).terreno_agricolo) = $event))
                }, null, 8 /* PROPS */, ["class", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_37, [
                _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_base_select, {
                  name: "forma_del_titolo",
                  options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                  isSelected: _unref(validazione).forma_del_titolo.value != '',
                  state: __props.readonly == true ?'disable':'',
                  validateTo: _unref(validazione).forma_del_titolo,
                  "onUpdate:validateTo": _cache[11] || (_cache[11] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            (_unref(regimeFiscale) == 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_40, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_base_input_checkbox, {
                      class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[12] || (_cache[12] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["class", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": ['valore_azienda','valore_fabbricati','valore_crediti_ceduti','valore_terreni'],
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}